import { useEffect, useState } from "react"
import { smartoltService } from "../../../services/smartolt.service.ts"
import { getRole } from "../../../utils/auth.ts"
import { useCompany } from "../../../context/CompanyContext.tsx"

const SMARTOLT_SETUP_ROLES = new Set(["company_owner", "admin", "super_admin"])

export function useSmartOLTAvailability() {
  const [loading, setLoading] = useState(true)
  const [available, setAvailable] = useState(false)
  const [tenant, setTenant] = useState<any>(null)
  const { company } = useCompany()

  useEffect(() => {
    let cancelled = false

    const loadTenantConfig = smartoltService.getTenantConfig
    if (typeof loadTenantConfig !== "function") {
      setAvailable(true)
      setTenant({ configured: true, enabled: true })
      setLoading(false)
      return () => {
        cancelled = true
      }
    }

    loadTenantConfig()
      .then((tenant) => {
        if (cancelled) return
        setTenant(tenant)
        const role = getRole()
        const canOpenSetup = SMARTOLT_SETUP_ROLES.has(role || "")
        const isVendorCompany = company?.company_type === "vendor"
        setAvailable(Boolean(tenant?.enabled) || (!isVendorCompany && canOpenSetup))
      })
      .catch(() => {
        if (!cancelled) {
          const role = getRole()
          const canOpenSetup = SMARTOLT_SETUP_ROLES.has(role || "")
          const isVendorCompany = company?.company_type === "vendor"
          setTenant(!isVendorCompany && canOpenSetup ? { configured: false, enabled: false, setup_required: true } : null)
          setAvailable(!isVendorCompany && canOpenSetup)
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [company?.company_type])

  return { loading, available, tenant }
}
